<template>
    <div>
        <div class="pb-1 mb-2 text-left md:text-center border-b border-gray-200 sm:mb-8 lg:mb-2 sm:text-left">
            <h3 class="font-medium leading-5 text-gray-900 text-md">
                Sunshine
            </h3>
        </div>
        <div v-if="isLoading" class="w-10 h-10 mt-20 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
        <div v-else>
            <div v-if="canViewSurgeonSunshine">
                <dl class="grid grid-cols-1 divide-y divide-gray-200 sm:mb-8 sm:divide-y-none lg:divide-gray-200 lg:divide-y sm:gap-5 lg:gap-0 lg:mb-0 lg:grid-cols-1 sm:grid-cols-3">

                    <div v-for="(year, index) in sunshineSummary"
                    :key = index
                    class="overflow-hidden bg-white sm:rounded-lg sm:shadow lg:shadow-none lg:rounded-none">
                        <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-0">
                        <dt class="text-sm font-medium text-gray-500">
                            Total {{ year.key }}
                        </dt>
                        <dd class="mt-1 text-xl font-bold text-green-600 sm:text-2xl md:text-3xl lg:text-2xl">
                            {{ moneyToString(year.year_totals.value) }}
                        </dd>
                        </div>
                    </div>
                </dl>
                <dl class="grid grid-cols-1 divide-y divide-gray-200 sm:mb-8 sm:divide-y-none lg:divide-gray-200 lg:divide-y sm:gap-5 lg:gap-0 lg:mb-0 lg:grid-cols-1 sm:grid-cols-2">
                    <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow lg:shadow-none lg:rounded-none">
                        <div class="py-3 sm:px-4 sm:py-5 lg:py-3 lg:px-0">
                        <dt class="text-sm font-medium text-gray-500">
                            Active Royalty Agreements
                        </dt>
                        <dd class="mt-1 text-xl font-bold text-blue-800 sm:text-2xl md:text-3xl lg:text-2xl">
                            {{ getRoyalties() }}
                        </dd>
                        </div>
                    </div>
                    <div class="overflow-hidden bg-white sm:rounded-lg sm:shadow lg:shadow-none lg:rounded-none">
                        <div class="py-3 sm:px-4 sm:py-5 lg:px-0">
                        <dt class="text-sm font-medium text-gray-500">
                            Active Consulting Agreements
                        </dt>
                        <dd class="mt-1 text-xl font-bold text-blue-800 sm:text-2xl md:text-3xl lg:text-2xl">
                            {{ getConsulting() }}
                        </dd>
                        </div>
                    </div>
                </dl>
            </div>
            <div v-else>
                <hidden-attribute-button
                    :model-id=surgeonId
                    model-type='surgeon'
                    attribute-name='sunshine_summary'
                    attribute-title='Sunshine Summary'
                >
                </hidden-attribute-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        sunshineSummary: {
            type: [Object, Array],
            required: true,
        },
        canViewSurgeonSunshine: {
            type: Boolean,
            required: true,
        },
        surgeonId: {
            type: Number,
            required: true,
        }
    },
    methods: {
        moneyToString( num ) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            return formatter.format(parseFloat(num));
        },
        getRoyalties() {
            var royalties = 0;
            this.sunshineSummary[0].nature_of_payment.buckets.forEach(function (item) {
               if (item.key === 'Royalty or License') {
                royalties = item.nature_cardinality.value;
               }
            });

            return royalties;
        },
        getConsulting() {
            var consulting = 0;
            this.sunshineSummary[0].nature_of_payment.buckets.forEach(function (item) {
               if (item.key === 'Consulting Fee') {
                consulting = item.nature_cardinality.value;
               }
            });

            return consulting;
        },
    },
}
</script>
